import 'tailwindcss/tailwind.css';
import 'virtual:windi.css';
import 'virtual:svg-icons-register';

import '@/utils/AutoRefresh';
import '@/common/init';
// 全局导入感觉有点慢
import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css';
import '@/style.scss';

import { createApp } from 'vue';
import App from './App.vue';
import { setupRouter } from '@/router';
import { setupStore } from '@/store';
import { setupTracker } from '@/utils/tracker';
import { setupI18n } from './locales/setupI18n';

async function bootstrap() {
    const app = createApp(App);

    // Configure store
    await setupStore(app);

    // Multilingual configuration
    await setupI18n(app);

    // Configure routing
    setupRouter(app);

    // Configure Tracker
    setupTracker();
    
    app.use(ElementPlus);

    app.mount('#app');
}

bootstrap();